// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-panel {
    /* z-index: 9999 !important; */
    top: 0px;
    left: 0px;
    background-color: var(--headerBackground);
    color: var(--headerColor);
    height: 36px;
    width: 100%;
    text-align: center;
    line-height: 36px;
    border-bottom: 1px solid var(--headerBorder);
}

.device-btn {
    height: 34px;
    width: 34px;
    min-width: unset !important;
    padding:unset !important;
    line-height: 34px;
    margin-left: 5px;
    margin-right: 5px;
    float: right;
}
  
.device-btn mat-icon {
    font-size: 24px;
    height: unset;
    width: unset;
}

.work-panel {
    position: absolute;
    top: 37px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    overflow: auto;
    background-color: var(--workPanelBackground);
}

.mat-table {
    overflow: auto;
    /* min-width: 1500px; */
    height: 100%;
}
  
.mat-header-cell.mat-sort-header-sorted {
    /* color: black; */
}

.mat-row {
    min-height: 34px;
    height: 34px;
    border-bottom-color: rgba(0,0,0,0.06);
}

.mat-cell {
    font-size: 13px;
}

.mat-cell ::ng-deep .mat-checkbox-inner-container {
    height: 16px;
    width: 16px;
    margin-left: 2px;
}

.mat-header-row {
    top: 0;
    position: sticky;
    z-index: 1;
    /* background-color: rgba(0,0,0,0.7); */
    /* background-color: rgb(30, 30, 30); */
    /* color: white; */
}
.mat-header-cell {
    /* color: white; */
    font-size: 11px;
}

.mat-column-toogle {
    overflow: visible;
    flex: 0 0 40px;
}

.mat-column-name {
    flex: 0 0 220px;
}

.mat-column-address {
    flex: 0 0 380px;
}

.mat-column-device {
    flex: 0 0 220px;
}

.mat-column-select {
    flex: 0 0 40px;
}

.my-header-filter ::ng-deep .mat-sort-header-content {
    display: unset;
    text-align: left;
}

.my-header-filter ::ng-deep .mat-sort-header-button {
    display: block;
    text-align: left;
    margin-top: 5px;
}

.my-header-filter span {
    padding-left: 5px;

}

.my-header-filter ::ng-deep .mat-sort-header-arrow {
    /* color: white; */
    top: -14px;
    right: 20px;
}

.my-header-filter-input {
    display: block; 
    margin-top: 4px;
    margin-bottom: 6px;
    /* color: white; */
    padding: 3px 1px 3px 2px;
    border-radius: 2px;
    border: 1px solid var(--formInputBackground);
    background-color: var(--formInputBackground);
    color: var(--formInputColor);
}

.my-header-filter-input:focus {
    padding: 3px 1px 3px 2px;
    border: 1px solid var(--formInputBorderFocus);
    background-color: var(--formInputBackgroundFocus);
}

.fab-reload {
    position: fixed !important;
    right: 10px !important;
    top: 40px !important;
    z-index: 9999 !important;
    color: var(--headerColor);
}

.fab-reload-active {
    transform: rotate(360deg);
    transition: all 0.5s ease-in-out;
}`, "",{"version":3,"sources":["webpack://./src/app/device/device.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,QAAQ;IACR,SAAS;IACT,yCAAyC;IACzC,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,2BAA2B;IAC3B,wBAAwB;IACxB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,cAAc;IACd,4CAA4C;AAChD;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,YAAY;AAChB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,qCAAqC;AACzC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,UAAU;IACV,uCAAuC;IACvC,uCAAuC;IACvC,kBAAkB;AACtB;AACA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;;AAErB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;IAClB,4CAA4C;IAC5C,4CAA4C;IAC5C,4BAA4B;AAChC;;AAEA;IACI,wBAAwB;IACxB,6CAA6C;IAC7C,iDAAiD;AACrD;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,oBAAoB;IACpB,wBAAwB;IACxB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IAIzB,gCAAgC;AACpC","sourcesContent":[".header-panel {\n    /* z-index: 9999 !important; */\n    top: 0px;\n    left: 0px;\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    height: 36px;\n    width: 100%;\n    text-align: center;\n    line-height: 36px;\n    border-bottom: 1px solid var(--headerBorder);\n}\n\n.device-btn {\n    height: 34px;\n    width: 34px;\n    min-width: unset !important;\n    padding:unset !important;\n    line-height: 34px;\n    margin-left: 5px;\n    margin-right: 5px;\n    float: right;\n}\n  \n.device-btn mat-icon {\n    font-size: 24px;\n    height: unset;\n    width: unset;\n}\n\n.work-panel {\n    position: absolute;\n    top: 37px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    overflow: auto;\n    background-color: var(--workPanelBackground);\n}\n\n.mat-table {\n    overflow: auto;\n    /* min-width: 1500px; */\n    height: 100%;\n}\n  \n.mat-header-cell.mat-sort-header-sorted {\n    /* color: black; */\n}\n\n.mat-row {\n    min-height: 34px;\n    height: 34px;\n    border-bottom-color: rgba(0,0,0,0.06);\n}\n\n.mat-cell {\n    font-size: 13px;\n}\n\n.mat-cell ::ng-deep .mat-checkbox-inner-container {\n    height: 16px;\n    width: 16px;\n    margin-left: 2px;\n}\n\n.mat-header-row {\n    top: 0;\n    position: sticky;\n    z-index: 1;\n    /* background-color: rgba(0,0,0,0.7); */\n    /* background-color: rgb(30, 30, 30); */\n    /* color: white; */\n}\n.mat-header-cell {\n    /* color: white; */\n    font-size: 11px;\n}\n\n.mat-column-toogle {\n    overflow: visible;\n    flex: 0 0 40px;\n}\n\n.mat-column-name {\n    flex: 0 0 220px;\n}\n\n.mat-column-address {\n    flex: 0 0 380px;\n}\n\n.mat-column-device {\n    flex: 0 0 220px;\n}\n\n.mat-column-select {\n    flex: 0 0 40px;\n}\n\n.my-header-filter ::ng-deep .mat-sort-header-content {\n    display: unset;\n    text-align: left;\n}\n\n.my-header-filter ::ng-deep .mat-sort-header-button {\n    display: block;\n    text-align: left;\n    margin-top: 5px;\n}\n\n.my-header-filter span {\n    padding-left: 5px;\n\n}\n\n.my-header-filter ::ng-deep .mat-sort-header-arrow {\n    /* color: white; */\n    top: -14px;\n    right: 20px;\n}\n\n.my-header-filter-input {\n    display: block; \n    margin-top: 4px;\n    margin-bottom: 6px;\n    /* color: white; */\n    padding: 3px 1px 3px 2px;\n    border-radius: 2px;\n    border: 1px solid var(--formInputBackground);\n    background-color: var(--formInputBackground);\n    color: var(--formInputColor);\n}\n\n.my-header-filter-input:focus {\n    padding: 3px 1px 3px 2px;\n    border: 1px solid var(--formInputBorderFocus);\n    background-color: var(--formInputBackgroundFocus);\n}\n\n.fab-reload {\n    position: fixed !important;\n    right: 10px !important;\n    top: 40px !important;\n    z-index: 9999 !important;\n    color: var(--headerColor);\n}\n\n.fab-reload-active {\n    transform: rotate(360deg);\n    -webkit-transition: all 0.5s ease-in-out;\n    -moz-transition: all 0.5s ease-in-out;\n    -o-transition: all 0.5s ease-in-out;\n    transition: all 0.5s ease-in-out;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
